<template>
  <b-sidebar id="settings-sidebar" aria-label="Settings" right no-header backdrop sidebar-class="sidebar-body">
    <template #default="{ hide }">
      <div class="center-settings">
        <div class="px-3 d-flex" style="background-color: #EDEDED">
          <h1 class="settings-title mr-auto">{{ $t("settings") }}</h1>
          <div class="row-close-icon">
            <b-button variant="default" @click="hide">
              <img alt="Close" src="../../../core/Images/icon-close-high-contrast.svg">
            </b-button>
          </div>
        </div>
        <div class="px-3 py-3">
          <nav class="mb-3">
            <b-nav vertical>
              <b-nav-item class="pb-2" link-classes="nav-item-text" @click="gotoChangePassword" @keyup.enter.space="gotoChangePassword" v-if="isValidAuthenticate()">
                {{ $t("settings_change_password") }}
              </b-nav-item>
              <div class="separator" v-if="isValidAuthenticate()" />
              <b-nav-text class="d-flex align-items-center pb-2">
                <div class="nav-item-text mr-auto" tabindex="0" :aria-label="$t('settings_language') + ': ' + settings.languageName">
                  {{ $t("settings_language") }}
                </div>
                <div class="nav-item-text">{{ settings.languageName }}</div>
                <b-dropdown variant="link" toggle-class="text-decoration-none" dropleft no-caret>
                  <template #button-content>
                    <img alt="Change language" src="../../../core/Images/Path_806.svg">
                  </template>
                  <b-dropdown-item v-for="language in settings.languages" :key="language.id"
                                   @click="changeLocale(language.culture_name, language.culture_display_name)">
                    {{ language.culture_display_name }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-nav-text>
              <div class="separator" />
              <b-nav-text class="d-flex align-items-center pb-2">
                <div class="nav-item-text mr-auto" tabindex="0" :aria-label="$t('settings_font_size') + ': ' + settings.fontSize + '%'">
                  {{ $t("settings_font_size") }}
                </div>
                <b-button class="font-button mr-2"  variant="link" @click="add(-25)"
                          aria-label="Decrease font size">
                  <img alt="Decrease font size" src="../../../core/Images/less-menu-high-contrast.svg">
                </b-button>
                <div class="nav-item-text">{{ settings.fontSize }}%</div>
                <b-button class="font-button ml-2"  variant="link" @click="add(25)"
                          aria-label="Increase font size">
                  <img alt="Increase font size" src="../../../core/Images/more-menu-high-contrast.svg">
                </b-button>
              </b-nav-text>
              <div class="separator"></div>
              <b-nav-item link-classes="nav-item-text" @click="logout" @keyup.enter.space="logout">
                {{ $t("settings_log_out") }}
              </b-nav-item>
            </b-nav>
          </nav>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { AuthService } from '../../../modules/Security/Services'
import router from "../../../router";
import {UtilsI18n, Zoom} from "../../../core/Utils";

export default {
  name: "SettingsSidebar",
  data() {
    return {
      settings: {
        fontSize: 100,
        languages: [],
        languageName: '',
      }
    }
  },
  methods: {
    gotoChangePassword() {
      this.$router.push({ name: 'ChangePassword' })
    },
    changeLocale(newLocale, newLocaleName) {
      UtilsI18n.changeLocale(newLocale)
      this.settings.languageName = newLocaleName
    },
    add(delta) {
      const newFontSize = this.settings.fontSize + delta
      if (newFontSize >= 100 && newFontSize <= 200) {
        this.settings.fontSize = newFontSize
        Zoom.setZoom(newFontSize)
      }
    },
    logout() {
      AuthService.logout();
      router.push({ name: 'Login'})
    },
    isValidAuthenticate(){
      return AuthService.isValidAuthenticate()
    }
  },
  mounted() {
    this.settings.fontSize = Zoom.getZoom()
    this.settings.languages = UtilsI18n.getLanguages()
    this.settings.languageName = UtilsI18n.getLanguageName()
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/core/Styles/mixins.styl"
@import "~@/core/Styles/variables.styl"

::v-deep
  .sidebar-body
    width 100%
    background-color white !important

.center-settings
  max-width: 720px
  margin-left auto
  margin-right auto

.settings-title
  font font-roboto-bold
  color black
  font-weight bold
  font-size 14px
  padding-top 127px
  padding-bottom 8px

.row-close-icon
  padding-top 45px
  padding-right 0

.nav-item-text
  padding-left 0
  padding-right 0
  color color-black
  font font-opensans-sem
  font-weight normal

.separator
  border-bottom 2pt solid #EDEDED
  height 8px
  margin-bottom 8px
</style>
